import React from 'react';

import { colorSystem } from '../../../theme';
import { CommentContent, MentionComponent } from '../types';
import { parseCommentString, Tokens } from './parseCommentString';

export function renderMarkup(
    content: CommentContent,
    { MentionComponent }: { MentionComponent: MentionComponent },
): React.ReactNode {
    const str = content.content;
    return parseCommentString(str)
        .map((token) => {
            switch (token.type) {
                case 'text': {
                    return token.content;
                }
                case 'link': {
                    return (
                        <a
                            href={token.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: colorSystem.primary[6] }}
                        >
                            {token.label}
                        </a>
                    );
                }
                case 'mention': {
                    return <MentionComponent key={token.id} id={token.id} label={token.label} />;
                }
                case 'quote': {
                    return (
                        <div
                            style={{
                                padding: 4,
                                paddingLeft: 8,
                                borderLeft: `4px solid ${colorSystem.neutral[2]}`,
                            }}
                        >
                            {
                                // TODO(fhur): recursively apply the parsing logic to support @-mentions in quotes and bullet points
                                // This is definitely an imperfect solution as it has performance implications and
                                // also some gotchas like nested bullet points
                                renderMarkup({ type: 'string.v1', content: token.content }, { MentionComponent })
                            }
                        </div>
                    );
                }
                case 'attachment': {
                    // Attachments are rendered separately below the text content
                    return null;
                }
                default: {
                    // @ts-expect-error
                    throw new Error('unhandled case: ' + token.type);
                }
            }
        })
        .filter((node) => node !== null)
        .map((r, i) => <React.Fragment key={i}>{r}</React.Fragment>);
}

/**
 * Extracts attachment file paths from comment content.
 * Used by CommentItem to render attachments separately from text.
 */
export function extractAttachments(content: CommentContent): string[] {
    const tokens = parseCommentString(content.content);
    return tokens
        .filter((token): token is Extract<Tokens, { type: 'attachment' }> => token.type === 'attachment')
        .map((token) => token.filePath);
}
